import { jsxs as t, jsx as C } from "react/jsx-runtime";
import { DEFAULT_METRIC_ICON_SIZE as l } from "./index.es2359.js";
function i({ size: e = l }) {
  return /* @__PURE__ */ t(
    "svg",
    {
      width: e,
      height: e,
      viewBox: "0 0 56 57",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: [
        /* @__PURE__ */ C("rect", { y: "0.468262", width: "56", height: "56", rx: "3", fill: "#F3F3FD" }),
        /* @__PURE__ */ C(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M27.4158 39.7725C27.9946 40.3091 28.8809 40.3091 29.4581 39.7725C31.0151 38.3286 34.0161 35.5432 36.078 33.6244C38.9719 30.9325 41.4377 28.3988 41.4377 24.3262C41.4377 21.0736 39.406 17.5723 34.9445 17.5723C32.643 17.5723 31.5065 18.7178 30.3052 19.9296C29.9043 20.335 29.2547 20.9681 28.8357 21.3735C28.6111 21.5921 28.2629 21.5921 28.0383 21.3735C27.6193 20.9681 26.9697 20.335 26.5688 19.9296C25.3675 18.7178 24.2325 17.5723 21.9295 17.5723C17.4695 17.5723 15.4377 21.0736 15.4377 24.3262C15.4377 28.3988 17.9036 30.9325 20.7975 33.6244C22.8594 35.5432 25.8604 38.3286 27.4158 39.7725Z",
            fill: "#E1E2FF"
          }
        ),
        /* @__PURE__ */ C(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M27.4158 39.7724C27.9946 40.309 28.8809 40.309 29.4581 39.7724C31.0151 38.3284 34.0161 35.543 36.078 33.6243C38.9719 30.9324 41.4377 28.3987 41.4377 24.3261C41.4377 21.0735 39.406 17.5721 34.9445 17.5721C32.643 17.5721 31.5065 18.7177 30.3052 19.9295C29.9043 20.3349 29.2547 20.968 28.8357 21.3734C28.6111 21.592 28.2629 21.592 28.0383 21.3734C27.6193 20.968 26.9697 20.3349 26.5688 19.9295C25.3675 18.7177 24.2325 17.5721 21.9295 17.5721C17.4695 17.5721 15.4377 21.0735 15.4377 24.3261C15.4377 28.3987 17.9036 30.9324 20.7975 33.6243C22.8594 35.543 25.8604 38.3284 27.4158 39.7724Z",
            stroke: "#5E63E5",
            strokeLinecap: "round"
          }
        )
      ]
    }
  );
}
i.__tags = [];
export {
  i as MetricHeartIcon
};
//# sourceMappingURL=index.es393.js.map
